import React, { Component } from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import '../Pages/Css/carousel.css';
import ReactImageZoom from 'react-image-zoom';
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import Swal from 'sweetalert2';
import axios from '../utils/axiosConfig';
var miStorage = window.localStorage;
class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contrato: -1,
      fotos: [],
      loadingFotos: false,
      nfotos: -1,
      currentIndex: 0,
      selectedItem: 0,
      isZoomed: false,
      mouseX: 0,
      mouseY: 0,
      predictionObject: [],
      comparision: {},
      fotosV: [],
      infoContainerNum: '',
      containerCode: '',
      containerOwner: '',
      visibleContain: false,
      selectedPhotoInfo: null,

    };
    // this.handleChangePredictionColor = this.handleChangePredictionColor.bind(this);
    this.imageRef = React.createRef();
    this.galleryRootRef = React.createRef();

  }

  normalizePhotoName = (value) => {
    if (!value) return "";
    const raw = String(value).trim().split("?")[0].split("#")[0];
    const parts = raw.split("/");
    return String(parts[parts.length - 1] || raw).toLowerCase();
  };

  resolvePredictionForPhoto = (photoItem, currentIndex) => {
    const predictions = Array.isArray(this.state.fotosV) ? this.state.fotosV : [];
    if (!photoItem || predictions.length === 0) return null;

    const photoName = this.normalizePhotoName(photoItem?.photo);
    const photoSource = this.normalizePhotoName(photoItem?.Source);

    return (
      predictions.find((item) => this.normalizePhotoName(item?.name) === photoName) ||
      predictions.find((item) => this.normalizePhotoName(item?.name) === photoSource) ||
      predictions.find((item) => {
        const candidate = this.normalizePhotoName(item?.name);
        return (
          (photoName && candidate.includes(photoName)) ||
          (photoSource && candidate.includes(photoSource)) ||
          (photoName && photoSource && (photoName.includes(candidate) || photoSource.includes(candidate)))
        );
      }) ||
      predictions[currentIndex] ||
      null
    );
  };

  componentDidMount() {
    this.setState({ contrato: this.props.contrato });
    this.loadGalleryData(this.props);
  }

  componentWillUnmount() {
    if (this.analyticsRetryTimer) {
      clearTimeout(this.analyticsRetryTimer);
      this.analyticsRetryTimer = null;
    }
  }

  scheduleAnalyticsRetry = (index, retryCount = 0) => {
    if (retryCount >= 8) return;
    if (this.analyticsRetryTimer) {
      clearTimeout(this.analyticsRetryTimer);
    }
    this.analyticsRetryTimer = setTimeout(() => {
      this.loadAllImageAnalitycs(index, retryCount + 1);
    }, 90);
  };

  componentDidUpdate(prevProps, prevState) {

    if (prevState.currentIndex !== this.state.currentIndex) {
      this.loadAllImageAnalitycs(this.state.currentIndex);
    }
    // console.log("prevProps: ", this.props.mostrarFotos);

    const mostrarFotosChanged = this.props.mostrarFotos !== prevProps.mostrarFotos;
    const contratoChanged = this.props.contrato !== prevProps.contrato;
    const infoContratoChanged = this.props.infoContrato !== prevProps.infoContrato;

    if (
      (mostrarFotosChanged && this.props.mostrarFotos) ||
      contratoChanged ||
      infoContratoChanged
    ) {
      this.loadGalleryData(this.props);
    }


    if (prevState.fotosV !== this.state.fotosV) {
      // console.log("Lo aplico aca ");
      this.loadAllImageAnalitycs(this.state.currentIndex);
    }
  }

  loadGalleryData = async (props) => {
    if (!props?.contrato || props.contrato === -1) return;
    const rawInfoContrato = typeof props.infoContrato === "string"
      ? props.infoContrato
      : (
        props.infoContrato?.ContainerNum ||
        props.infoContrato?.containerNum ||
        props.infoContrato?.Ref ||
        ""
      );
    const formattedContainerNum = String(rawInfoContrato || "").replace(/\s+/g, "");
    this.setState({ contrato: props.contrato, fotos: [], fotosV: [], infoContainerNum: formattedContainerNum });
    await this.getFotos(props.contrato);
    await this.getInfoAditionalContrato();
    await this.getFotosContratoVisualLogistic(props.contrato);
  }


  //TODO: Cambiar el endpoint para traer las fotos de acuerdo al contrato
  async getInfoAditionalContrato() {
    let token = localStorage.getItem('tkn');
    var contrato = {
      "contrato": this.props.contrato
    };
    // console.log("Contrato a utilizar: ", contrato);
    axios.post(process.env.REACT_APP_SERVER + '/operaciones/getcontractvisuallogistic', JSON.stringify(contrato), {
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      withCredentials: true

    }).then((response) => {
      const comparisonResult = response?.data?.info?.assets?.[0]?.comparison?.[0]?.result || {};
      // console.log(comparisonResult);
      this.setState({ comparision: comparisonResult });
    }).catch((err) => {
      console.error(err);
    });
  }

  ocultar() {
    const objectBoxes = document.querySelectorAll(".object-box");
    objectBoxes.forEach(objectBox => {
      objectBox.style.display = "none";
    });
  }

  mostrar() {
    const objectBoxes = document.querySelectorAll(".object-box");
    objectBoxes.forEach(objectBox => {
      objectBox.style.display = "block";
    });
  }

  eliminar() {
    var elementos = document.getElementsByClassName('object-box');
    var elementosArray = Array.from(elementos);
    elementosArray.forEach(function (elemento) {
      elemento.parentNode.removeChild(elemento);
    });

    elementos = document.getElementsByClassName('object-box2');
    elementosArray = Array.from(elementos);
    elementosArray.forEach(function (elemento) {
      elemento.parentNode.removeChild(elemento);
    });

    elementos = document.getElementsByClassName('object-box3');
    elementosArray = Array.from(elementos);
    elementosArray.forEach(function (elemento) {
      elemento.parentNode.removeChild(elemento);
    });
  }

  mostrarInfo(f) {
    this.setState({ selectedPhotoInfo: f || null });
  }

  handleMouseEnter = (e) => {
    this.setState({ isZoomed: true });

    this.handleMouseMove(e);
  };

  handleMouseLeave = () => {
    this.setState({ isZoomed: false });
  };

  handleMouseMove = (e) => {
    const { isZoomed } = this.state;

    if (isZoomed) {
      const rect = e.target.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;

      this.setState({ mouseX, mouseY });
    }
  };

  handlePhotoLoad = (index) => {
    if (index !== this.state.currentIndex) return;
    this.loadAllImageAnalitycs(index);
  };

  getScopedElementById = (id) => {
    if (!id) return null;
    const root = this.galleryRootRef.current;
    if (!root) {
      return document.getElementById(id);
    }

    const escapedId = String(id).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    return root.querySelector(`[id="${escapedId}"]`) || document.getElementById(id);
  };

  getScopedElements = (selector) => {
    const root = this.galleryRootRef.current;
    if (!root) return Array.from(document.querySelectorAll(selector));
    return Array.from(root.querySelectorAll(selector));
  };

  getGalleryContainer = () => {
    const root = this.galleryRootRef.current;
    if (!root) return document.getElementById('ModalGaleriaW');
    return root.closest('#ModalGaleriaW') || document.getElementById('ModalGaleriaW');
  };

  getActivePhotoElement = (photoId) => {
    if (!photoId) return null;
    const root = this.galleryRootRef.current;
    const escapedId = String(photoId).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    const selectedSlideImage = root?.querySelector(`.carousel .slide.selected img[id="${escapedId}"]`);
    return selectedSlideImage || this.getScopedElementById(photoId);
  };

  handleChange = (currentIndex, event) => {
    this.setState({ currentIndex: currentIndex, selectedItem: currentIndex });
    this.eliminar();
    var fotos = this.state.fotos;
    var f = fotos[currentIndex];
    // console.log("Posicion actual: ", currentIndex);
    // console.log("Foto seleccionada: ", this.state.selectedItem);
    this.mostrarInfo(f);

  };

  /* 
  Funcion adapatada para traer toda la informacion y predicciones
  desde un contrato
  */
  getFotosContratoVisualLogistic = async (contrato) => {
    try {
      // console.log("El contrato: ", contrato);
      // console.log("Server URL: ", process.env.REACT_APP_SERVER);
      let servicioContrato = {
        contrato: contrato,
      }
      let token = localStorage.getItem('tkn');
      if (!token) {
        throw new Error("Token no encontrado en localStorage");
      }

      // Usamos await para esperar la resoluciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de la promesa
      const response = await axios.post(process.env.REACT_APP_SERVER + '/operaciones/getfotoscontractvisuallogistic',
        JSON.stringify(servicioContrato),
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      // console.log("Respuesta nuevo endpoint: ", response.data);
      // console.log("Respuesta nuevo endpoint predictions: ", response.data.info.contract_predictions);
      // console.log("IAtem currentIndex e info: " + this.state.currentIndex + " selectedItmen info: " + this.state.selectedItem);
      this.setState({ fotosV: response.data.info.contract_predictions })

    } catch (error) {
      console.error("Error al consumir el endpoint: ", error);
    }
  }


  /**
 * Dibuja un ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã‚Â¦ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã¢â‚¬Å“bounding boxÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â sobre un elemento padre, 
 * a partir de coordenadas normalizadas [0ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ1] en un array de 8 puntos.
 *
 * @param {HTMLElement} parent    ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ Nodo donde aÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±adiremos el <div>.
 * @param {number[]}   bbox      ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ [x1,y1, x2,y2, x3,y3, x4,y4] relativo 0ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ1.
 * @param {string}     className ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ Clase CSS para el estilo base (e.g. 'object-box2').
 * @param {object}     opts      ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ Opciones: { borderColor, fill, lineWidth }.
 */
  drawBoundingDiv(parent, bbox, className, opts = {}) {
    const { borderColor = 'red', fill = false, fillColor = 'rgba(255,0,0,0.1)', lineWidth = 2 } = opts;
    // 1) extraer extremos para rectÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo alineado
    const xs = [bbox[0], bbox[2], bbox[4], bbox[6]];
    const ys = [bbox[1], bbox[3], bbox[5], bbox[7]];
    const minX = Math.min(...xs), maxX = Math.max(...xs);
    const minY = Math.min(...ys), maxY = Math.max(...ys);

    // 2) porcentajes y ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo
    const leftPct = minX;
    const topPct = minY;
    const widthPct = maxX - minX;
    const heightPct = maxY - minY;
    const angleRad = Math.atan2(bbox[3] - bbox[1], bbox[2] - bbox[0]);

    // 3) crear <div> y asignar estilos
    const box = document.createElement('div');
    box.className = className;
    Object.assign(box.style, {
      position: 'absolute',
      left: `${leftPct * 100}%`,
      top: `${topPct * 100}%`,
      width: `${widthPct * 100}%`,
      height: `${heightPct * 100}%`,
      transformOrigin: 'top left',
      transform: `rotate(${angleRad}rad)`,
      border: `${lineWidth}px solid ${borderColor}`,
      pointerEvents: 'none',
      ...(fill ? { backgroundColor: fillColor } : {})
    });

    parent.appendChild(box);
    return box;
  }



  /* Funcion para cargar las predicciones de acuerdo a la visualLogisitc 
  en el caso que lo tenga
  */
  loadAllImageAnalitycs = async (currentIndex, retryCount = 0) => {
    return this.handleClick(null, currentIndex, retryCount);
    this.eliminar();
    // console.log("initial state fotosV: ", this.state.fotosV);
    let nameFotoActual = this.state.fotos && this.state.fotos[currentIndex]?.photo;
    // console.log("el name de la foto actual es: ", nameFotoActual);
    const currentPhotoItem = this.state.fotos && this.state.fotos[currentIndex];
    let infoByFotoActual = this.resolvePredictionForPhoto(currentPhotoItem, currentIndex);
    let fotos = this.state.fotos;
    let f = fotos[currentIndex];
    let photo = this.getActivePhotoElement(f?.IDPhoto);




    // console.log("IDPHOTO INFO =>", photo);
    // console.log("IMAGE ANALITYCS => Informacion de carga asociada a la foto actual **", infoByFotoActual);
    const infojson = this.getScopedElementById('infojson');
    const infoAddJson = this.getScopedElementById('infofoto2');
    if (!infojson || !infoAddJson) return;
    if (infojson) infojson.innerHTML = "";
    if (infoAddJson) infoAddJson.innerHTML = "";
    const img = new Image();
    // FunciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n para sanitizar id
    function sanitizeId(id) {
      return id.replace(/[^a-zA-Z0-9-_]/g, '_');
    }
    if (!f?.Source || !photo || !photo.complete || photo.clientWidth === 0 || photo.clientHeight === 0) {
      this.scheduleAnalyticsRetry(currentIndex, retryCount);
      return;
    }
    if (this.analyticsRetryTimer) {
      clearTimeout(this.analyticsRetryTimer);
      this.analyticsRetryTimer = null;
    }
    img.src = f?.Source;
    // img.className = 'image-container'
    img.onload = () => {
      this.setState({
        containerCode: '',
        containerOwner: '',
        visibleContain: false,
      });
      // console.log("IMAGE ANALITYCS => Ancho:", img.width);
      try {
        if (!infoByFotoActual) {
          infojson.innerHTML = "<div class='attribute_class' style='padding:8px;'>No se encontro analitica IA asociada para esta imagen.</div>";
          infoAddJson.innerHTML = "<div class='attribute_class' style='padding:8px;'>No hay analisis detallado disponible para esta imagen.</div>";
          return;
        }
        //Lista para manejar la vista de la lista bruta en acordeon
        var predictions = Array.isArray(infoByFotoActual?.predictions) ? infoByFotoActual.predictions : [];
        if (predictions.length === 0) {
          infojson.innerHTML = "<div class='attribute_class' style='padding:8px;'>La imagen no trae bounding boxes ni etiquetas analiticas.</div>";
          infoAddJson.innerHTML = "<div class='attribute_class' style='padding:8px;'>No hay atributos analiticos para mostrar.</div>";
          return;
        }
        // console.log("Predicciones desde el global: ==>", predictions);
        //TODO: cambiar en produccion

        // console.log("IMAGE ANALITYCS => predictions", predictions);
        predictions.filter(Boolean).forEach((prediction, index) => {
          if (!prediction?.tag_name || !prediction?.bounding_box) return;
          const sanitizedTagName = sanitizeId(prediction.tag_name);
          var cadena = `
          <div class="accordion-item">
            <div class="accordion-header">
              <button class="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${index}" aria-expanded="true">
                ${prediction.tag_name}
              </button>
            </div>
            <div id="collapse-${index}" class="accordion-collapse collapse show">
              <div class="accordion-body">
                <ul>
        `;

          const tagname = prediction.tag_name;
          // console.log("pruebatag", tagname);
          const boundingBox = prediction.bounding_box;
          var width = boundingBox.right - boundingBox.left;
          var height = boundingBox.bottom - boundingBox.top;
          // console.log(width + "   -   " + height);
          const modalPrueba = this.getScopedElementById('prueba');
          const modalContainer = this.getGalleryContainer();
          const panelinfo = this.getScopedElementById('panelinfo');
          const panelinfo2 = document.getElementById('panelinfo2');


          //const modalRect = modalContainer.getBoundingClientRect();
          const imageRect = photo.getBoundingClientRect();
          const offsetX = imageRect.left; // Offset en el eje X
          const offsetY = imageRect.top; // Offset en el eje Y
          const offsetW = imageRect.width;
          const offsetH = imageRect.height;
          var diferenciaoriginalW = imageRect.width / img.width;
          var diferenciaoriginalH = imageRect.height / img.height;


          const objectBox = document.createElement("div");
          objectBox.className = "object-box";
          objectBox.title = prediction.tag_name;
          objectBox.id = `box-${index}`; // Asignar un ID ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºnico
          objectBox.style.border = "2px solid blue";
          // Establece las dimensiones del cuadro despuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©s de la rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
          objectBox.style.width = width * diferenciaoriginalW + "px";
          objectBox.style.height = height * diferenciaoriginalH + "px";

          var body = document.body;
          // console.log("w. imagen: " + offsetW + " | " + "w. body: " + body.clientWidth + " | " + "w. modal: " + modalContainer.clientWidth + "| w. panel: " + panelinfo.clientWidth);
          // console.log("h. imagen: " + offsetH + " | " + "h. body: " + body.clientHeight + " | " + "h. modal: " + modalContainer.clientHeight);
          // Verificar el diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o responsive
          var isResponsive = window.matchMedia("(max-width: 768px)").matches;

          var restanteW, restanteH;
          if (isResponsive) {
            // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en columna (responsive)
            restanteW = ((modalContainer - offsetW) / 2);
            restanteH = (((modalContainer) - offsetH - 3) / 2);
            // console.log("IMAGE ANALITYCS => is resposnive ", restanteW, " ", restanteH);
          } else {
            // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en fila (no responsive)
            restanteW = ((modalContainer.clientWidth - offsetW) / 2) + panelinfo.clientWidth - 250;
            restanteH = (((modalContainer.clientHeight) - offsetH - 3) / 2);
          }



          // console.log(restanteW + "   restante+   " + offsetX + "   -    " + boundingBox[0]);
          // console.log(restanteH + "   restante+   " + offsetY + "   -    " + boundingBox[1]);
          //const left = (boundingBox[0]*diferenciaoriginalW) + offsetX;
          let left, top;

          if (isResponsive) {
            left = (boundingBox.left * diferenciaoriginalW) + 35;
            top = (boundingBox.top * diferenciaoriginalH);
          } else {
            left = (boundingBox.left * diferenciaoriginalW) + restanteW - ((modalContainer.clientWidth - modalPrueba.clientWidth));
            top = (boundingBox.top * diferenciaoriginalH) + restanteH - ((modalContainer.clientHeight - modalPrueba.clientHeight));
          }

          // console.log("IMAGE ANALITYCS: => top boundingbox", top);
          //(boundingBox[1]*diferenciaoriginalH)

          // console.log(left + "   resultado+   " + top);
          // console.log(boundingBox[0] + " {left} " + offsetX);
          // console.log(boundingBox[1] + " {top} " + offsetY);
          // objectBox.style.position = "absolute";
          // objectBox.style.left = left + "px";
          // objectBox.style.top = top + "px";
          objectBox.style.left = (prediction.bounding_box.left * 100) + "%";
          objectBox.style.top = (prediction.bounding_box.top * 100) + "%";
          objectBox.style.width = (width * 100) + "%";
          objectBox.style.height = (height * 100) + "%";
          // Agrega el elemento .object-box al contenedor
          if (photo?.parentNode) {
              photo.parentNode.appendChild(objectBox);
        }

          // console.log("*?* ", prediction);
          const attributes = Array.isArray(prediction.attributes) ? prediction.attributes.filter(Boolean) : [];
          let hasAditionalInfo = false;
          // console.log("IMAGE ANALITYCS => attributes", attributes);
          // console.log("IMAGE ANALITYCS => tipo de datos attributes", typeof attributes);
          let containerCode = '';
          let containerOwner = '';
          attributes.forEach((attribute, attrIndex) => {
            if (!attribute?.name) return;
            const name = attribute.name;
            // console.log("pruebatag ", name);
            // console.log("*?* length ", attributes.length);
            const value = attribute.value;
            // if (name.includes('Container_Code')) {
            //   this.setState({
            //     containerCode: value,
            //   })
            // }
            // if (name.includes('Container_Owner')) {
            //   this.setState({
            //     containerOwner: value,
            //   })
            // }

            // if (this.state.containerCode !== '' && this.state.containerOwner !== '') {
            //   const formattedFusion = this.state.containerOwner.replace(' ', '') + this.state.containerCode.replace(' ', '');
            //   console.log("formatted fussion :", formattedFusion);
            //   if (formattedFusion === this.state.infoContainerNum) {
            //     this.setState({ visibleContain: true });
            //   }
            // }


            // cadena += "<div class='attribute_class'>" + name + "<ul>";

            const content = value; // Cambio aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­: asigno value a content
            // console.log("IMAGE ANALITYCS => content tipo de variable: ", typeof content);
            // console.log("IMAGE ANALITYCS => content", content);
            let countString = 0;
            if (Array.isArray(content)) {
              content.filter(Boolean).forEach((contenido, contentIndex) => {
                const contentValue = contenido?.content;
                if (!contentValue) return;

                hasAditionalInfo = true;
                attributeAddHtml += `<li class='attribute_content'>${contentValue}</li>`;
                cadena += "<div class='attribute_class'>" + name + "<ul>";
                cadena += `<li class='content_content' data-box-id='box-${sanitizeId(contentValue)}'>${contentValue}</li>`;

                if (name.includes('Container_Code')) {
                  containerCode = String(contentValue).replace(/\s+/g, '');
                }

                if (name.includes('Container_Owner')) {
                  containerOwner = String(contentValue).replace(/\s+/g, '');
                }

                if (containerCode !== '' && containerOwner !== '') {
                  const formattedFusion = containerOwner + containerCode;
                  if (formattedFusion === this.state.infoContainerNum) {
                    this.setState({
                      containerCode: containerCode,
                      containerOwner: containerOwner,
                      visibleContain: true,
                    });
                  } else {
                    this.setState({
                      containerCode: containerCode,
                      containerOwner: containerOwner,
                      visibleContain: false,
                    });
                  }
                }

                if (!Array.isArray(contenido?.boundingBox) || contenido.boundingBox.length < 8) return;

                const boundingBox2 = contenido.boundingBox;
                // console.log(boundingBox);
                // console.log("bounding box 2: ", boundingBox2);
                // const width2 = Math.sqrt((boundingBox2[2] - boundingBox2[0]) ** 2 + (boundingBox2[3] - boundingBox2[1]) ** 2);
                // const height2 = Math.sqrt((boundingBox2[6] - boundingBox2[0]) ** 2 + (boundingBox2[7] - boundingBox2[1]) ** 2);
                // const angle2 = Math.atan2(boundingBox2[3] - boundingBox2[1], boundingBox2[2] - boundingBox2[0]);

                const bb2 = contenido.boundingBox;

                // 1) Vector de la arista superior (ancho normalizado)
                const dx = bb2[2] - bb2[0];
                const dy = bb2[3] - bb2[1];
                const widthPct = Math.hypot(dx, dy);            // ancho como fracciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de img width

                // 2) Vector de la arista izquierda (alto normalizado)
                const dx2 = bb2[6] - bb2[0];
                const dy2 = bb2[7] - bb2[1];
                const heightPct = Math.hypot(dx2, dy2);          // alto como fracciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de img height

                // 3) ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Ângulo en radianes sobre el eje X
                const angle2 = Math.atan2(dy, dx);

                // 4) PosiciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n (top-left) ya normalizada:
                const leftPct = bb2[0];
                const topPct = bb2[1];

                if (name.includes('Container_Code')) {
                  // console.log(name);
                  containerCode = contenido.content.replace(' ', '');
                }

                if (name.includes('Container_Owner')) {
                  // console.log(name);
                  containerOwner = contenido.content.replace(' ', '');
                }

                if (containerCode !== '' && containerOwner !== '') {
                  const formattedFusion = containerOwner + containerCode.slice(0, 6);
                  // console.log("formatted fussion :", formattedFusion);
                  // console.log(this.state.infoContainerNum.slice(4, 10));
                  const formattedContainerNum = this.state.infoContainerNum.slice(0, 10);
                  if (formattedFusion === formattedContainerNum) {
                    this.setState({
                      containerCode: containerCode,
                      containerOwner: containerOwner,
                      visibleContain: true,
                    });
                  } else {
                    this.setState({
                      containerCode: containerCode,
                      containerOwner: containerOwner,
                      visibleContain: false,
                    });
                  }
                }

                const modalPrueba2 = this.getScopedElementById('prueba');
                const modalContainer2 = this.getGalleryContainer();
                const panelinfo2 = this.getScopedElementById('panelinfo');
                //const modalRect = modalContainer.getBoundingClientRect();
                const imageRect2 = photo.getBoundingClientRect();
                const offsetX2 = imageRect.left; // Offset en el eje X
                const offsetY2 = imageRect.top; // Offset en el eje Y
                const offsetW2 = imageRect.width;
                const offsetH2 = imageRect.height;
                var diferenciaoriginalW2 = imageRect2.width / img.width;
                var diferenciaoriginalH2 = imageRect2.height / img.height;

                // const objectBox = document.createElement("div");
                // objectBox.className = "object-box2";
                // objectBox.title = contenido.content;
                // objectBox.id = `box-${sanitizeId(contenido.content)}`; // Asignar un ID ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºnico
                // objectBox.style.transformOrigin = "top left";
                // objectBox.style.border = "2px solid #6ABFF4";
                // objectBox.style.transform = `rotate(${angle2}rad)`;

                // // Establece las dimensiones del cuadro despuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©s de la rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
                // objectBox.style.width = width2 * diferenciaoriginalW2 + "px";
                // objectBox.style.height = height2 * diferenciaoriginalH2 + "px";

                const objectBox = document.createElement("div");
                objectBox.className = "object-box2";
                objectBox.id = `box-${sanitizeId(contentValue)}`;
                objectBox.title = contentValue;
                Object.assign(objectBox.style, {
                  position: "absolute",
                  left: `${leftPct * 100}%`,
                  top: `${topPct * 100}%`,
                  width: `${widthPct * 100}%`,
                  height: `${heightPct * 100}%`,
                  transformOrigin: "top left",
                  transform: `rotate(${angle2}rad)`,
                  border: "2px solid #6ABFF4",
                  pointerEvents: "none"
                });

                var body = document.body;

                // Verificar el diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o responsive
                // var isResponsive = window.matchMedia("(max-width: 768px)").matches;

                // var restanteW2, restanteH2;
                // if (isResponsive) {
                //   console.log("IMAGE ANALITYCS => is resposnive");
                //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en columna (responsive)
                //   restanteW2 = ((modalContainer2 - offsetW) / 2);
                //   restanteH2 = (((modalContainer2) - offsetH - 3) / 2);
                // } else {
                //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en fila (no responsive)
                //   restanteW2 = ((modalContainer2.clientWidth - offsetW) / 2) + panelinfo.clientWidth - 370;
                //   restanteH2 = (((modalContainer2.clientHeight) - offsetH - 3) / 2);
                // }

                // // const left2 = (boundingBox2[0] * diferenciaoriginalW2) + restanteW2 - ((modalContainer2.clientWidth - modalPrueba2.clientWidth));
                // // const top2 = (boundingBox2[1] * diferenciaoriginalH2) + restanteH2 - ((modalContainer2.clientHeight - modalPrueba2.clientHeight));;
                // console.log("IMAGE ANALITYCS: => top2 boundingbox", top2);
                // var left2, top2;

                // if (isResponsive) {
                //   left2 = (boundingBox2[0] * diferenciaoriginalW2);
                //   top2 = (boundingBox2[1] * diferenciaoriginalH2);
                // } else {
                //   left2 = (boundingBox2[0] * diferenciaoriginalW2) + restanteW2 - ((modalContainer2.clientWidth - modalPrueba2.clientWidth));
                //   top2 = (boundingBox2[1] * diferenciaoriginalH2) + restanteH2 - ((modalContainer2.clientHeight - modalPrueba2.clientHeight));
                // }

                // objectBox.style.position = "absolute";
                // objectBox.style.left = left2 + "px";
                // objectBox.style.top = top2 + "px";
                // Agrega el elemento .object-box al contenedor
                if (photo?.parentNode) {
              photo.parentNode.appendChild(objectBox);
        }
                //document.querySelector("body").parentNode.appendChild(objectBox);

                this.mostrar();
              });
              attributeAddHtml += `</ul></div>`;
              if (attributeAddHtml.includes("<li")) {
                infoAddJson.innerHTML += attributeAddHtml;
              }
            } else if (typeof content === 'string') {
              countString++;
              // Si es una cadena, crea un nuevo elemento HTML para mostrar su valor
              // console.log("pruebatag cadena string entre en el metodo");
              let iconHTML = '';
              if (name === 'ID') {
                iconHTML = `<i class='bx bx-id-card bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (name === 'color') {
                iconHTML = `<i class='bx bxs-color-fill bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (name === 'status') {
                iconHTML = `<i class='bx bx-stats bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (name === 'condition') {
                iconHTML = `<i class='bx bx-box bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }

              if (name === 'door_status') {
                iconHTML = `<i class='bx bx-door-open bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              var attributeValueHtml = `<div class='attribute_class'><span class='container_span_iconName'>${iconHTML} <span class='color_name_attribute'>${name.toUpperCase()}</span></span>${content}</div>`;
              if (infoAddJson.innerHTML.includes("No hay informaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n adicional asociada")) {
              }
              // Agrega el nuevo elemento al contenedor infoAddJson
              hasAditionalInfo = true;
              infoAddJson.innerHTML += attributeValueHtml;

              // console.log("pruebatag ", attributeValueHtml);
            } else {
              console.error("attribute.value no es un array:", value); // Cambio aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­: uso value en lugar de attribute.value

              cadena += "</ul></div>";
              // AÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±adir al infoAddJson
              let iconHTML = '';
              if (attribute.name === 'ID') {
                iconHTML = `<i class='bx bx-id-card bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (attribute.name === 'color') {
                iconHTML = `<i class='bx bxs-color-fill bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (attribute.name === 'status') {
                iconHTML = `<i class='bx bx-stats bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (attribute.name === 'condition') {
                iconHTML = `<i class='bx bx-box bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }

              if (attribute.name === 'door_status') {
                iconHTML = `<i class='bx bx-door-open bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              var attributeAddHtml = `
                  <div class='attribute_class'>
                      <span>${iconHTML} <span>${(attribute.name).toUpperCase()}:</span> ${attribute.value}</span>
                    <ul>
                `;
              // // attribute.value.forEach(contenido => {
              // //   attributeAddHtml += `<li class='attribute_content' >${contenido.content}</li>`;
              // // });
              attributeAddHtml += `</ul></div>`;
              // console.log("pruebatag ", attributeAddHtml);
            }

            // console.log("Contador de cadenas: ", countString);
          });



          const words = Array.isArray(prediction.lines) ? prediction.lines.filter(Boolean) : [];
          // console.log(words);
          words.forEach((word, wordIndex) => {
            // cadena += `<li class='word_content' data-box-id='box-${sanitizeId(word.content)}-${wordIndex}'>${word.content}</li>`;
            // const boundingBox2 = word.boundingBox;
            // console.log(boundingBox);
            // // const width2 = Math.sqrt((boundingBox2[2] - boundingBox2[0]) ** 2 + (boundingBox2[3] - boundingBox2[1]) ** 2);
            // // const height2 = Math.sqrt((boundingBox2[6] - boundingBox2[0]) ** 2 + (boundingBox2[7] - boundingBox2[1]) ** 2);
            // // const angle2 = Math.atan2(boundingBox2[3] - boundingBox2[1], boundingBox2[2] - boundingBox2[0]);

            // const bb3 = word.boundingBox;

            // // 1) Vector de la arista superior (ancho normalizado)
            // const dx = bb3[2] - bb3[0];
            // const dy = bb3[3] - bb3[1];
            // const widthPct = Math.hypot(dx, dy);            // ancho como fracciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de img width

            // // 2) Vector de la arista izquierda (alto normalizado)
            // const dx2 = bb3[6] - bb3[0];
            // const dy2 = bb3[7] - bb3[1];
            // const heightPct = Math.hypot(dx2, dy2);          // alto como fracciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de img height

            // // 3) ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Ângulo en radianes sobre el eje X
            // const angle2 = Math.atan2(dy, dx);

            // // 4) PosiciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n (top-left) ya normalizada:
            // const leftPct = bb3[0];
            // const topPct = bb3[1];

            // const modalPrueba2 = document.getElementById('prueba');
            // const modalContainer2 = document.getElementById('ModalGaleriaW');
            // const panelinfo2 = document.getElementById('panelinfo');
            // //const modalRect = modalContainer.getBoundingClientRect();
            // const imageRect2 = photo.getBoundingClientRect();
            // const offsetX2 = imageRect.left; // Offset en el eje X
            // const offsetY2 = imageRect.top; // Offset en el eje Y
            // const offsetW2 = imageRect.width;
            // const offsetH2 = imageRect.height;
            // var diferenciaoriginalW2 = imageRect2.width / img.width;
            // var diferenciaoriginalH2 = imageRect2.height / img.height;

            // const objectBox = document.createElement("div");
            // objectBox.className = "object-box2";
            // objectBox.id = `box-${sanitizeId(word.content)}-${wordIndex}`;
            // objectBox.title = contenido.content;
            // Object.assign(objectBox.style, {
            //   position: "absolute",
            //   left: `${leftPct * 100}%`,
            //   top: `${topPct * 100}%`,
            //   width: `${widthPct * 100}%`,
            //   height: `${heightPct * 100}%`,
            //   transformOrigin: "top left",
            //   transform: `rotate(${angle2}rad)`,
            //   border: "2px solid red",
            //   pointerEvents: "none"
            // });

            // const objectBox = document.createElement("div");
            // objectBox.className = "object-box2";
            // objectBox.title = word.content;
            // objectBox.id = `box-${sanitizeId(word.content)}-${wordIndex}`; // Asignar un ID ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºnico
            // objectBox.style.transformOrigin = "top left";
            // objectBox.style.transform = `rotate(${angle2}rad) scale(1)`;
            // objectBox.style.border = "2px solid red";


            // Establece las dimensiones del cuadro despuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©s de la rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
            // objectBox.style.width = width2 * diferenciaoriginalW2 + "px";
            // objectBox.style.height = height2 * diferenciaoriginalH2 + "px";

            // var body = document.body;

            // Verificar el diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o responsive
            // var isResponsive = window.matchMedia("(max-width: 768px)").matches;

            // var restanteW2, restanteH2;


            // if (isResponsive) {
            //   console.log("IMAGE ANALITYCS => is resposnive");
            //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en columna (responsive)
            //   restanteW2 = ((modalContainer2 - offsetW) / 2);
            //   restanteH2 = (((modalContainer2) - offsetH - 3) / 2);
            // } else {
            //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en fila (no responsive)
            //   restanteW2 = ((modalContainer2.clientWidth - offsetW2) / 2) + panelinfo.clientWidth - 370;
            //   restanteH2 = (((modalContainer2.clientHeight) - offsetH2 - 3) / 2);
            // }

            // const left2 = (boundingBox2[0] * diferenciaoriginalW2) + restanteW2 - ((modalContainer2.clientWidth - modalPrueba2.clientWidth));
            // const top2 = (boundingBox2[1] * diferenciaoriginalH2) + restanteH2 - ((modalContainer2.clientHeight - modalPrueba2.clientHeight));
            // console.log("IMAGE ANALITYCS: => top3 boundingbox", top2);
            // var left2, top2;

            // if (isResponsive) {
            //   left2 = (boundingBox2[0] * diferenciaoriginalW2);
            //   top2 = (boundingBox2[1] * diferenciaoriginalH2);
            // } else {
            //   left2 = (boundingBox2[0] * diferenciaoriginalW2) + restanteW2 - ((modalContainer2.clientWidth - modalPrueba2.clientWidth));
            //   top2 = (boundingBox2[1] * diferenciaoriginalH2) + restanteH2 - ((modalContainer2.clientHeight - modalPrueba2.clientHeight));
            // }
            // objectBox.style.position = "absolute";
            // objectBox.style.left = left2 + "px";
            // objectBox.style.top = top2 + "px";
            // Agrega el elemento .object-box al contenedor
            if (photo?.parentNode) {
              photo.parentNode.appendChild(objectBox);
            }
            //document.querySelector("body").parentNode.appendChild(objectBox);
            // 1) La entrada en el acordeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
            cadena += `
                        <li class='word_content' data-box-id='box-${sanitizeId(word.content)}-${wordIndex}'>
                          ${word.content}
                        </li>`;

            // 2) bb: [x1,y1, x2,y2, x3,y3, x4,y4] todos en 0ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ1
            const bb = word.boundingBox;
            // console.log("IMAGE ANALITYCS => bb: ", word);
            // console.log("IMAGE ANALITYCS => bb: ", bb);

            // console.log("ANCHO", photo.clientWidth);
            // console.log("ALTO", photo.clientHeight);

            const returnLista = [118, 262, 130, 337, 122, 338, 110, 263]


            // const lista = [0.5507, 0.2365, 0.5588, 0.4387, 0.5163, 0.44, 0.5131, 0.2377];
            // Encuentra los extremos
            const xs = [bb[0], bb[2], bb[4], bb[6]];
            const ys = [bb[1], bb[3], bb[5], bb[7]];
            const minX = Math.min(...xs), maxX = Math.max(...xs);
            const minY = Math.min(...ys), maxY = Math.max(...ys);

            // 3) Porcentajes y ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo
            const leftPct = minX;
            const topPct = minY;
            const widthPct = maxX - minX;
            const heightPct = maxY - minY;
            const angleRad = Math.atan2(bb[3] - bb[1], bb[2] - bb[0]);

            // 4) Crea y posiciona el div en %
            const wordBox = document.createElement('div');
            wordBox.className = 'object-box2';
            wordBox.id = `box-${sanitizeId(word.content)}-${wordIndex}`;
            wordBox.title = word.content;
            Object.assign(wordBox.style, {
              position: 'absolute',
              left: `${leftPct * 100}%`,
              top: `${topPct * 100}%`,
              width: `${widthPct * 100}%`,
              height: `${heightPct * 100}%`,
              transformOrigin: 'top left',
              transform: `rotate(${angleRad}rad)!important`,
              border: '2px solid red',
              pointerEvents: 'none'
            });

            if (photo?.parentNode) {
              photo.parentNode.appendChild(wordBox);
          }

            this.mostrar();
          });

          if (cadena.includes("<li>")) {
            cadena += "</ul></div>";
          } else {
            cadena.replace("<ul>", "");
            cadena += "</div>";
          }
          infojson.innerHTML += cadena;

        });

        //Manejo de cambio de colores cuando se selscciona un item de la lista del acorrdion

        /* Esta funcion cambia de colores los cuadros que se elige en la lista del analisiss de la imagen
         para poder intercatuar con los boundinboxes del lado de la lista desplegada  
        */

        this.getScopedElements('.word_content, .attribute_content, .content_content').forEach(wordContentActive => {
          wordContentActive.addEventListener('click', function () {
            const clickedWord = this.dataset.boxId;
            console.warn("IMAGE ANALITYCS => item clickeado: " + clickedWord);

            // Restablecer el color de todos los recuadros
            (photo?.parentNode?.querySelectorAll('.object-box2') || []).forEach(box => {
              box.style.borderColor = ""; // Restablecer el color del borde
              box.style.animation = ""; // Restablecer la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n

            });

            // Cambiar el color del borde del recuadro correspondiente
            const box = photo?.parentNode?.querySelector(`#${CSS.escape(clickedWord)}`);
            if (box) {
              box.style.borderColor = "green"; // Cambiar el color del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­

              // Obtener el ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo de rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n del cuadro
              const angle2 = window.getComputedStyle(box).getPropertyValue('transform');
              // console.log("IMAGE ANALITYCS => Grados de tranfpormacion cuadro: ", angle2);

              // Aplicar la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n con el ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo de rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
              const pulseAnimation = `
                @keyframes pulseAnimation {
                    0% { transform: ${angle2} scale(1); }
                    50% { transform: ${angle2} scale(1.1); }
                    100% { transform: ${angle2} scale(1); }
                }
            `;

              // Crear un estilo para la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
              const style = document.createElement('style');
              style.type = 'text/css';
              style.innerHTML = pulseAnimation;

              // Agregar el estilo al head del documento
              document.head.appendChild(style);

              // Aplicar la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n al cuadro
              box.style.animation = "pulseAnimation 1s ease-in-out infinite";
            }
          });
        });




        // Manejo del estado de colapso del acordeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
        this.getScopedElements('.accordion-button').forEach((button, index) => {
          button.classList.add('active'); // AÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±adir la clase active inicialmente
          const targetId = `box-${index}`;
          // console.log("IMAGE ANALITYCS => acorrdion taqgandme :", targetId);
          button.addEventListener('click', function () {
            const collapseTargetId = button.getAttribute('data-bs-target').substring(1);
            const collapseElement = this.galleryRootRef.current?.querySelector(`#${CSS.escape(collapseTargetId)}`);
            const boxId = `box-${index}`;

            collapseElement.addEventListener('hidden.bs.collapse', function () {
              button.classList.add('collapsed');
              button.classList.remove('active'); // Add active class when expanded
              resetBoxStyles();
              highlightBox(boxId);

              setTimeout(() => {
                hideBackdrop(boxId);
              }, 500);
            });

            collapseElement.addEventListener('shown.bs.collapse', function () {
              button.classList.remove('collapsed');
              button.classList.add('active'); // Remove active class when collapsed
              resetBoxStyles();
              highlightBox(boxId);

              setTimeout(() => {
                hideBackdrop(boxId);
              }, 500);
            });
          });

          // Restablecer el color del borde de todos los cuadros
        });

        // Restablecer el color y el grosor del borde de todos los cuadros cuando se hace clic en cualquier otro elemento
        this.galleryRootRef.current?.addEventListener('click', function (event) {
          if (!event.target.classList.contains('accordion-button')) {
            resetBoxStyles();
            hideBackdrop();
          }
        });

        function resetBoxStyles() {
          (photo?.parentNode?.querySelectorAll('.object-box, .object-box2') || []).forEach(box => {
            box.style.borderColor = ""; // Restablecer el color del borde
            box.style.borderWidth = "2px"; // Restablecer el grosor del borde
          });
        }

        function highlightBox(boxId) {
          const box = photo?.parentNode?.querySelector(`#${CSS.escape(boxId)}`);
          if (box) {
            box.style.borderColor = "blue"; // Cambiar el color del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.borderWidth = "4px"; // Cambiar el grosor del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.backgroundColor = 'rgba(0, 0, 255, 0.5)'
          }
        }




        function hideBackdrop(boxId) {

          const masks = photo?.parentNode?.querySelectorAll('.mask') || [];
          // console.log("IMAGE ANALITYCS => boxId: ", boxId);
          const box = boxId ? photo?.parentNode?.querySelector(`#${CSS.escape(boxId)}`) : null;
          if (box) {
            box.style.borderColor = "blue"; // Cambiar el color del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.borderWidth = "2px"; // Cambiar el grosor del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.backgroundColor = ''
          }
          // Remover todos los backdrops y mÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡scaras


          masks.forEach(mask => {
            mask.remove();
          });
        }





      } catch (error) {
        console.error("Error al obtener datos JSON:", error);
      }
    };
  }


  handleClick = async (event, forcedIndex = null, retryCount = 0) => {
    event?.preventDefault?.();
    this.eliminar();
    const infojson = this.getScopedElementById('infojson');
    const infoAddJson = this.getScopedElementById('infofoto2');
    if (!infojson || !infoAddJson) return;
    // console.log(`El ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­ndice de la 1foto actual es: ${this.state.currentIndex}`);
    var fotos = Array.isArray(this.state.fotos) ? this.state.fotos : [];
    const safeIndex = forcedIndex ?? this.state.currentIndex ?? 0;
    var f = fotos[safeIndex];
    if (!f?.IDPhoto || !f?.photo || !f?.Source) {
      this.scheduleAnalyticsRetry(safeIndex, retryCount);
      return;
    }
    // console.log("foto Info: ", f);
    // console.log("info++", this.state.infoContainerNum);
    // console.log("info++", this.state.containerCode);
    // console.log("info++", this.state.containerOwner);

    this.mostrarInfo(f);

    var photo = this.getActivePhotoElement(f.IDPhoto);
    if (!photo) {
      this.scheduleAnalyticsRetry(safeIndex, retryCount);
      return;
    }
    if (!photo.complete || photo.clientWidth === 0 || photo.clientHeight === 0) {
      this.scheduleAnalyticsRetry(safeIndex, retryCount);
      return;
    }
    // console.log("Photo onclick ID: ", photo);

    const img = new Image();
    // FunciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n para sanitizar id
    function sanitizeId(id) {
      return id.replace(/[^a-zA-Z0-9-_]/g, '_');
    }

    infojson.innerHTML = "<div class='attribute_class' style='padding:8px;'>Cargando analitica...</div>";
    infoAddJson.innerHTML = "<div class='attribute_class' style='padding:8px;'>Cargando analisis detallado...</div>";
    var jsonData = (await this.getFotosjSON(f.photo));
    // console.log("datos de la prediccion: ", jsonData);

    img.src = f.Source;
    img.onload = () => {
      // console.log("Ancho:", img.width);
      try {
        //Lista para manejar la vista de la lista bruta en acordeon
        var predictions = Array.isArray(jsonData?.predictions) ? jsonData.predictions : [];
        if (predictions.length === 0) {
          infojson.innerHTML = "<div class='attribute_class' style='padding:8px;'>La imagen no trae bounding boxes ni etiquetas analiticas.</div>";
          infoAddJson.innerHTML = "<div class='attribute_class' style='padding:8px;'>No hay atributos analiticos para mostrar.</div>";
          return;
        }
        infojson.innerHTML = "";
        infoAddJson.innerHTML = "";
        let hasAnyAdditionalInfo = false;
        // console.log(predictions);

        // console.log("IMAGE ANALITYCS => predictions", predictions);
        predictions.filter(Boolean).forEach((prediction, index) => {
          if (!prediction?.tag_name || !prediction?.bounding_box) return;
          const sanitizedTagName = sanitizeId(prediction.tag_name);
          var cadena = `
          <div class="accordion-item">
            <div class="accordion-header">
              <button class="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#collapse-${index}" aria-expanded="true">
                ${prediction.tag_name}
              </button>
            </div>
            <div id="collapse-${index}" class="accordion-collapse collapse show">
              <div class="accordion-body">
                <ul>
        `;

          const tagname = prediction.tag_name;
          const boundingBox = prediction.bounding_box;
          if (
            boundingBox.left === undefined ||
            boundingBox.top === undefined ||
            (boundingBox.right === undefined && boundingBox.width === undefined) ||
            (boundingBox.bottom === undefined && boundingBox.height === undefined)
          ) {
            return;
          }
          var width = boundingBox.width ?? (boundingBox.right - boundingBox.left);
          var height = boundingBox.height ?? (boundingBox.bottom - boundingBox.top);
          // console.log(width + "   -   " + height);
          const modalPrueba = this.getScopedElementById('prueba');
          const modalContainer = this.getGalleryContainer();
          const panelinfo = this.getScopedElementById('panelinfo');
          const panelinfo2 = document.getElementById('panelinfo2');


          //const modalRect = modalContainer.getBoundingClientRect();
          const imageRect = photo.getBoundingClientRect();
          const offsetX = imageRect.left; // Offset en el eje X
          const offsetY = imageRect.top; // Offset en el eje Y
          const offsetW = imageRect.width;
          const offsetH = imageRect.height;
          var diferenciaoriginalW = imageRect.width / img.width;
          var diferenciaoriginalH = imageRect.height / img.height;


          const objectBox = document.createElement("div");
          objectBox.className = "object-box";
          objectBox.title = prediction.tag_name;
          objectBox.id = `box-${index}`; // Asignar un ID ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºnico
          objectBox.style.border = "2px solid blue";
          // Establece las dimensiones del cuadro despuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©s de la rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
          objectBox.style.width = width * diferenciaoriginalW + "px";
          objectBox.style.height = height * diferenciaoriginalH + "px";

          var body = document.body;
          // console.log("w. imagen: " + offsetW + " | " + "w. body: " + body.clientWidth + " | " + "w. modal: " + modalContainer.clientWidth + "| w. panel: " + panelinfo.clientWidth);
          // console.log("h. imagen: " + offsetH + " | " + "h. body: " + body.clientHeight + " | " + "h. modal: " + modalContainer.clientHeight);
          //var restanteW = ((body.clientWidth-modalContainer.clientWidth)/2)+((modalContainer.clientWidth-offsetW)/2);

          // Verificar el diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o responsive
          var isResponsive = window.matchMedia("(max-width: 768px)").matches;

          var restanteW, restanteH;
          if (isResponsive) {
            // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en columna (responsive)
            restanteW = ((modalContainer - offsetW) / 2);
            restanteH = (((modalContainer) - offsetH - 3) / 2);
            // console.log("IMAGE ANALITYCS => is resposnive ", restanteW, " ", restanteH);
          } else {
            // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en fila (no responsive)
            restanteW = ((modalContainer.clientWidth - offsetW) / 2) + panelinfo.clientWidth - 250;
            restanteH = (((modalContainer.clientHeight) - offsetH - 3) / 2);
          }


          // console.log(restanteW + "   restante+   " + offsetX + "   -    " + boundingBox[0]);
          // console.log(restanteH + "   restante+   " + offsetY + "   -    " + boundingBox[1]);
          //const left = (boundingBox[0]*diferenciaoriginalW) + offsetX;
          let left, top;

          if (isResponsive) {
            left = (boundingBox.left * diferenciaoriginalW) + 35;
            top = (boundingBox.top * diferenciaoriginalH);
          } else {
            left = (boundingBox.left * diferenciaoriginalW) + restanteW - ((modalContainer.clientWidth - modalPrueba.clientWidth));
            top = (boundingBox.top * diferenciaoriginalH) + restanteH - ((modalContainer.clientHeight - modalPrueba.clientHeight));
          }
          //(boundingBox[1]*diferenciaoriginalH)

          // console.log(left + "   resultado+   " + top);
          // console.log(boundingBox[0] + " {left} " + offsetX);
          // console.log(boundingBox[1] + " {top} " + offsetY);
          // objectBox.style.position = "absolute";
          // objectBox.style.left = left + "px";
          // objectBox.style.top = top + "px";
          objectBox.style.left = (boundingBox.left * 100) + "%";
          objectBox.style.top = (boundingBox.top * 100) + "%";
          objectBox.style.width = (width * 100) + "%";
          objectBox.style.height = (height * 100) + "%";
          // Agrega el elemento .object-box al contenedor
          if (photo?.parentNode) {
              photo.parentNode.appendChild(objectBox);
        }

          // console.log("*?* ", prediction);
          const attributes = Array.isArray(prediction.attributes) ? prediction.attributes.filter(Boolean) : [];
          let hasAditionalInfo = false;
          // console.log("IMAGE ANALITYCS => attributes", attributes);
          // console.log("IMAGE ANALITYCS => tipo de datos attributes", typeof attributes);
          let containerCode = '';
          let containerOwner = '';
          attributes.forEach((attribute, attrIndex) => {
            if (!attribute?.name) return;
            const name = attribute.name;
            // console.log("*?* ", name);
            // console.log("*?* length ", attributes.length);
            const value = attribute.value;
            // console.log(value);
            // cadena += "<div class='attribute_class'>" + name + "<ul>";


            const content = value; // Cambio aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­: asigno value a content
            // console.log("IMAGE ANALITYCS => content tipo de variable: ", typeof content);
            // console.log("IMAGE ANALITYCS => content", content);
            if (Array.isArray(content)) {
              let attributeAddHtml = `
                  <div class='attribute_class'>
                    <span class='container_span_iconName'>${name}</span>
                    <ul>
              `;
              content.filter(Boolean).forEach((contenido, contentIndex) => {
                const contentValue = contenido?.content;
                if (!contentValue) return;
                hasAditionalInfo = true;
                attributeAddHtml += `<li class='attribute_content'>${contentValue}</li>`;
                cadena += "<div class='attribute_class'>" + name + "<ul>";
                cadena += `<li class='content_content' data-box-id='box-${sanitizeId(contentValue)}'>${contentValue}</li>`;

                if (name.includes('Container_Code')) {
                  containerCode = String(contentValue).replace(/\s+/g, '');
                }

                if (name.includes('Container_Owner')) {
                  containerOwner = String(contentValue).replace(/\s+/g, '');
                }

                if (containerCode !== '' && containerOwner !== '') {
                  const formattedFusion = containerOwner + containerCode;
                  if (formattedFusion === this.state.infoContainerNum) {
                    this.setState({
                      containerCode: containerCode,
                      containerOwner: containerOwner,
                      visibleContain: true,
                    });
                  } else {
                    this.setState({
                      containerCode: containerCode,
                      containerOwner: containerOwner,
                      visibleContain: false,
                    });
                  }
                }

                if (!Array.isArray(contenido?.boundingBox) || contenido.boundingBox.length < 8) return;
                const boundingBox2 = contenido.boundingBox;
                // console.log(boundingBox);
                // const width2 = Math.sqrt((boundingBox2[2] - boundingBox2[0]) ** 2 + (boundingBox2[3] - boundingBox2[1]) ** 2);
                // const height2 = Math.sqrt((boundingBox2[6] - boundingBox2[0]) ** 2 + (boundingBox2[7] - boundingBox2[1]) ** 2);
                // const angle2 = Math.atan2(boundingBox2[3] - boundingBox2[1], boundingBox2[2] - boundingBox2[0]);

                const bb2 = contenido.boundingBox;

                // 1) Vector de la arista superior (ancho normalizado)
                const dx = bb2[2] - bb2[0];
                const dy = bb2[3] - bb2[1];
                const widthPct = Math.hypot(dx, dy);            // ancho como fracciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de img width

                // 2) Vector de la arista izquierda (alto normalizado)
                const dx2 = bb2[6] - bb2[0];
                const dy2 = bb2[7] - bb2[1];
                const heightPct = Math.hypot(dx2, dy2);          // alto como fracciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n de img height

                // 3) ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Ângulo en radianes sobre el eje X
                const angle2 = Math.atan2(dy, dx);

                // 4) PosiciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n (top-left) ya normalizada:
                const leftPct = bb2[0];
                const topPct = bb2[1];

                const modalPrueba2 = this.getScopedElementById('prueba');
                const modalContainer2 = this.getGalleryContainer();
                const panelinfo2 = this.getScopedElementById('panelinfo');
                //const modalRect = modalContainer.getBoundingClientRect();
                const imageRect2 = photo.getBoundingClientRect();
                const offsetX2 = imageRect.left; // Offset en el eje X
                const offsetY2 = imageRect.top; // Offset en el eje Y
                const offsetW2 = imageRect.width;
                const offsetH2 = imageRect.height;
                var diferenciaoriginalW2 = imageRect2.width / img.width;
                var diferenciaoriginalH2 = imageRect2.height / img.height;

                // const objectBox = document.createElement("div");
                // objectBox.className = "object-box2";
                // objectBox.title = contenido.content;
                // objectBox.id = `box-${sanitizeId(contenido.content)}`; // Asignar un ID ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºnico
                // objectBox.style.transformOrigin = "top left";
                // objectBox.style.border = "2px solid #6ABFF4";
                // objectBox.style.transform = `rotate(${angle2}rad)`;

                // // Establece las dimensiones del cuadro despuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©s de la rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
                // objectBox.style.width = width2 * diferenciaoriginalW2 + "px";
                // objectBox.style.height = height2 * diferenciaoriginalH2 + "px";

                // var body = document.body;

                // // Verificar el diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o responsive
                // var isResponsive = window.matchMedia("(max-width: 768px)").matches;

                // var restanteW2, restanteH2;
                // if (isResponsive) {
                //   console.log("IMAGE ANALITYCS => is resposnive");
                //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en columna (responsive)
                //   restanteW2 = ((modalContainer2 - offsetW) / 2);
                //   restanteH2 = (((modalContainer2) - offsetH - 3) / 2);
                // } else {
                //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en fila (no responsive)
                //   restanteW2 = ((modalContainer2.clientWidth - offsetW) / 2) + panelinfo.clientWidth - 370;
                //   restanteH2 = (((modalContainer2.clientHeight) - offsetH - 3) / 2);
                // }

                // var left2, top2;

                // if (isResponsive) {
                //   left2 = (boundingBox2[0] * diferenciaoriginalW2);
                //   top2 = (boundingBox2[1] * diferenciaoriginalH2);
                // } else {
                //   left2 = (boundingBox2[0] * diferenciaoriginalW2) + restanteW2 - ((modalContainer2.clientWidth - modalPrueba2.clientWidth));
                //   top2 = (boundingBox2[1] * diferenciaoriginalH2) + restanteH2 - ((modalContainer2.clientHeight - modalPrueba2.clientHeight));
                // }

                // objectBox.style.position = "absolute";
                // objectBox.style.left = left2 + "px";
                // objectBox.style.top = top2 + "px";
                const objectBox = document.createElement("div");
                objectBox.className = "object-box2";
                objectBox.id = `box-${sanitizeId(contentValue)}`;
                objectBox.title = contentValue;
                Object.assign(objectBox.style, {
                  position: "absolute",
                  left: `${leftPct * 100}%`,
                  top: `${topPct * 100}%`,
                  width: `${widthPct * 100}%`,
                  height: `${heightPct * 100}%`,
                  transformOrigin: "top left",
                  transform: `rotate(${angle2}rad)`,
                  border: "2px solid #6ABFF4",
                  pointerEvents: "none"
                });
                // Agrega el elemento .object-box al contenedor
                if (photo?.parentNode) {
              photo.parentNode.appendChild(objectBox);
        }
                //document.querySelector("body").parentNode.appendChild(objectBox);

                this.mostrar();
              });
                attributeAddHtml += `</ul></div>`;
                if (attributeAddHtml.includes("<li")) {
                  infoAddJson.innerHTML += attributeAddHtml;
                  hasAnyAdditionalInfo = true;
                }
            } else if (typeof content === 'string') {
              // Si es una cadena, crea un nuevo elemento HTML para mostrar su valor
              let iconHTML = '';
              if (name === 'ID') {
                iconHTML = `<i class='bx bx-id-card bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (name === 'color') {
                iconHTML = `<i class='bx bxs-color-fill bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (name === 'status') {
                iconHTML = `<i class='bx bx-stats bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (name === 'condition') {
                iconHTML = `<i class='bx bx-box bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }

              if (name === 'door_status') {
                iconHTML = `<i class='bx bx-door-open bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }

              var attributeValueHtml = `<div class='attribute_class'><span class='container_span_iconName'>${iconHTML} <span class='color_name_attribute'>${name.toUpperCase()}</span></span>${content}</div>`;
              if (infoAddJson.innerHTML.includes("No hay informaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n adicional asociada")) {
              }
              // Agrega el nuevo elemento al contenedor infoAddJson
              hasAditionalInfo = true;
              infoAddJson.innerHTML += attributeValueHtml;
              hasAnyAdditionalInfo = true;
            } else {
              console.error("attribute.value no es un array:", value); // Cambio aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­: uso value en lugar de attribute.value

              cadena += "</ul></div>";
              // AÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±adir al infoAddJson
              let iconHTML = '';
              if (attribute.name === 'ID') {
                iconHTML = `<i class='bx bx-id-card bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (attribute.name === 'color') {
                iconHTML = `<i class='bx bxs-color-fill bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (attribute.name === 'status') {
                iconHTML = `<i class='bx bx-stats bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              if (attribute.name === 'condition') {
                iconHTML = `<i class='bx bx-box bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }

              if (attribute.name === 'door_status') {
                iconHTML = `<i class='bx bx-door-open bx-tada' style="position: relative; top: 2px; margin-right: 1px; font-size: 20px;"></i>`;
              }
              var attributeAddHtml = `
                  <div class='attribute_class'>
                      <span>${iconHTML} ${attribute.name}: ${attribute.value}</span>
                    <ul>
                `;
              // // attribute.value.forEach(contenido => {
              // //   attributeAddHtml += `<li class='attribute_content' >${contenido.content}</li>`;
              // // });
              attributeAddHtml += `</ul></div>`;
            }

          });

          const words = Array.isArray(prediction.lines) ? prediction.lines.filter(Boolean) : [];
          // console.log(words);
          words.forEach((word, wordIndex) => {
            if (!word?.content || !Array.isArray(word?.boundingBox) || word.boundingBox.length < 8) return;
            cadena += `<li class='word_content' data-box-id='box-${sanitizeId(word.content)}-${wordIndex}'>${word.content}</li>`;
            const boundingBox2 = word.boundingBox;
            // console.log(boundingBox);
            // const width2 = Math.sqrt((boundingBox2[2] - boundingBox2[0]) ** 2 + (boundingBox2[3] - boundingBox2[1]) ** 2);
            // const height2 = Math.sqrt((boundingBox2[6] - boundingBox2[0]) ** 2 + (boundingBox2[7] - boundingBox2[1]) ** 2);
            // const angle2 = Math.atan2(boundingBox2[3] - boundingBox2[1], boundingBox2[2] - boundingBox2[0]);

            // const modalPrueba2 = document.getElementById('prueba');
            // const modalContainer2 = document.getElementById('ModalGaleriaW');
            // const panelinfo2 = document.getElementById('panelinfo');
            // //const modalRect = modalContainer.getBoundingClientRect();
            // const imageRect2 = photo.getBoundingClientRect();
            // const offsetX2 = imageRect.left; // Offset en el eje X
            // const offsetY2 = imageRect.top; // Offset en el eje Y
            // const offsetW2 = imageRect.width;
            // const offsetH2 = imageRect.height;
            // var diferenciaoriginalW2 = imageRect2.width / img.width;
            // var diferenciaoriginalH2 = imageRect2.height / img.height;

            // const objectBox = document.createElement("div");
            // objectBox.className = "object-box2";
            // objectBox.title = word.content;
            // objectBox.id = `box-${sanitizeId(word.content)}-${wordIndex}`; // Asignar un ID ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Âºnico
            // objectBox.style.transformOrigin = "top left";
            // objectBox.style.transform = `rotate(${angle2}rad) scale(1)`;
            // objectBox.style.border = "2px solid red";


            // // Establece las dimensiones del cuadro despuÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â©s de la rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
            // objectBox.style.width = width2 * diferenciaoriginalW2 + "px";
            // objectBox.style.height = height2 * diferenciaoriginalH2 + "px";

            // var body = document.body;

            // // Verificar el diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o responsive
            // var isResponsive = window.matchMedia("(max-width: 768px)").matches;

            // var restanteW2, restanteH2;


            // if (isResponsive) {
            //   console.log("IMAGE ANALITYCS => is resposnive");
            //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en columna (responsive)
            //   restanteW2 = ((modalContainer2 - offsetW) / 2);
            //   restanteH2 = (((modalContainer2) - offsetH - 3) / 2);
            // } else {
            //   // Ajuste para diseÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±o en fila (no responsive)
            //   restanteW2 = ((modalContainer2.clientWidth - offsetW2) / 2) + panelinfo.clientWidth - 370;
            //   restanteH2 = (((modalContainer2.clientHeight) - offsetH2 - 3) / 2);
            // }

            // var left2, top2;

            // if (isResponsive) {
            //   left2 = (boundingBox2[0] * diferenciaoriginalW2);
            //   top2 = (boundingBox2[1] * diferenciaoriginalH2);
            // } else {
            //   left2 = (boundingBox2[0] * diferenciaoriginalW2) + restanteW2 - ((modalContainer2.clientWidth - modalPrueba2.clientWidth));
            //   top2 = (boundingBox2[1] * diferenciaoriginalH2) + restanteH2 - ((modalContainer2.clientHeight - modalPrueba2.clientHeight));
            // }

            // objectBox.style.position = "absolute";
            // objectBox.style.left = left2 + "px";
            // objectBox.style.top = top2 + "px";
            // Agrega el elemento .object-box al contenedor

            // 2) bb: [x1,y1, x2,y2, x3,y3, x4,y4] todos en 0ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬Ãƒâ€¦Ã‚Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¢ÃƒÆ’Ã‚Â¢ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡Ãƒâ€šÃ‚Â¬ÃƒÆ’Ã¢â‚¬Â¦ÃƒÂ¢Ã¢â€šÂ¬Ã…â€œ1
            const bb = word.boundingBox;
            // console.log("IMAGE ANALITYCS => bb: ", word);
            // console.log("IMAGE ANALITYCS => bb: ", bb);

            // console.log("ANCHO", photo.clientWidth);
            // console.log("ALTO", photo.clientHeight);

            const returnLista = [118, 262, 130, 337, 122, 338, 110, 263]


            // const lista = [0.5507, 0.2365, 0.5588, 0.4387, 0.5163, 0.44, 0.5131, 0.2377];
            // Encuentra los extremos
            const xs = [bb[0], bb[2], bb[4], bb[6]];
            const ys = [bb[1], bb[3], bb[5], bb[7]];
            const minX = Math.min(...xs), maxX = Math.max(...xs);
            const minY = Math.min(...ys), maxY = Math.max(...ys);

            // 3) Porcentajes y ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo
            const leftPct = minX;
            const topPct = minY;
            const widthPct = maxX - minX;
            const heightPct = maxY - minY;
            const angleRad = Math.atan2(bb[3] - bb[1], bb[2] - bb[0]);

            // 4) Crea y posiciona el div en %
            const wordBox = document.createElement('div');
            wordBox.className = 'object-box2';
            wordBox.id = `box-${sanitizeId(word.content)}-${wordIndex}`;
            wordBox.title = word.content;
            Object.assign(wordBox.style, {
              position: 'absolute',
              left: `${leftPct * 100}%`,
              top: `${topPct * 100}%`,
              width: `${widthPct * 100}%`,
              height: `${heightPct * 100}%`,
              transformOrigin: 'top left',
              transform: `rotate(${angleRad}rad)!important`,
              border: '2px solid red',
              pointerEvents: 'none'
            });

            if (photo?.parentNode) {
              photo.parentNode.appendChild(wordBox);
          }
            //document.querySelector("body").parentNode.appendChild(objectBox);

            this.mostrar();
          });

          if (cadena.includes("<li>")) {
            cadena += "</ul></div>";
          } else {
            cadena.replace("<ul>", "");
            cadena += "</div>";
          }
          infojson.innerHTML += cadena;

        });

        if (!hasAnyAdditionalInfo && infoAddJson.innerHTML.trim() === "") {
          infoAddJson.innerHTML = "<div class='attribute_class' style='padding:8px;'>No hay informacion adicional asociada</div>";
        }

        //Manejo de cambio de colores cuando se selscciona un item de la lista del acorrdion

        /* Esta funcion cambia de colores los cuadros que se elige en la lista del analisiss de la imagen
         para poder intercatuar con los boundinboxes del lado de la lista desplegada  
        */

        document.querySelectorAll('.word_content, .attribute_content, .content_content').forEach(wordContentActive => {
          wordContentActive.addEventListener('click', function () {
            const clickedWord = this.dataset.boxId;
            console.warn("IMAGE ANALITYCS => item clickeado: " + clickedWord);

            // Restablecer el color de todos los recuadros
            document.querySelectorAll('.object-box2').forEach(box => {
              box.style.borderColor = ""; // Restablecer el color del borde
              box.style.animation = ""; // Restablecer la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n

            });

            // Cambiar el color del borde del recuadro correspondiente
            const box = document.getElementById(clickedWord);
            if (box) {
              box.style.borderColor = "green"; // Cambiar el color del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­

              // Obtener el ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo de rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n del cuadro
              const angle2 = window.getComputedStyle(box).getPropertyValue('transform');
              // console.log("IMAGE ANALITYCS => Grados de tranfpormacion cuadro: ", angle2);

              // Aplicar la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n con el ÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡ngulo de rotaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
              const pulseAnimation = `
                @keyframes pulseAnimation {
                    0% { transform: ${angle2} scale(1); }
                    50% { transform: ${angle2} scale(1.1); }
                    100% { transform: ${angle2} scale(1); }
                }
            `;

              // Crear un estilo para la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
              const style = document.createElement('style');
              style.type = 'text/css';
              style.innerHTML = pulseAnimation;

              // Agregar el estilo al head del documento
              document.head.appendChild(style);

              // Aplicar la animaciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n al cuadro
              box.style.animation = "pulseAnimation 1s ease-in-out infinite";
            }
          });
        });




        // Manejo del estado de colapso del acordeÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n
        document.querySelectorAll('.accordion-button').forEach((button, index) => {
          button.classList.add('active'); // AÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â±adir la clase active inicialmente
          const targetId = `box-${index}`;
          // console.log("IMAGE ANALITYCS => acorrdion taqgandme :", targetId);
          button.addEventListener('click', function () {
            const collapseElement = document.getElementById(button.getAttribute('data-bs-target').substring(1));
            const boxId = `box-${index}`;

            collapseElement.addEventListener('hidden.bs.collapse', function () {
              button.classList.add('collapsed');
              button.classList.remove('active'); // Add active class when expanded
              resetBoxStyles();
              highlightBox(boxId);

              setTimeout(() => {
                hideBackdrop(boxId);
              }, 500);
            });

            collapseElement.addEventListener('shown.bs.collapse', function () {
              button.classList.remove('collapsed');
              button.classList.add('active'); // Remove active class when collapsed
              resetBoxStyles();
              highlightBox(boxId);

              setTimeout(() => {
                hideBackdrop(boxId);
              }, 500);
            });
          });

          // Restablecer el color del borde de todos los cuadros
        });

        // Restablecer el color y el grosor del borde de todos los cuadros cuando se hace clic en cualquier otro elemento
        document.addEventListener('click', function (event) {
          if (!event.target.classList.contains('accordion-button')) {
            resetBoxStyles();
            hideBackdrop();
          }
        });

        function resetBoxStyles() {
          document.querySelectorAll('.object-box, object-box2').forEach(box => {
            box.style.borderColor = ""; // Restablecer el color del borde
            box.style.borderWidth = "2px"; // Restablecer el grosor del borde
          });
        }

        function highlightBox(boxId) {
          const box = document.getElementById(boxId);
          if (box) {
            box.style.borderColor = "blue"; // Cambiar el color del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.borderWidth = "4px"; // Cambiar el grosor del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.backgroundColor = 'rgba(0, 0, 255, 0.5)'
          }
        }




        function hideBackdrop(boxId) {

          const masks = document.querySelectorAll('.mask');
          // console.log("IMAGE ANALITYCS => boxId: ", boxId);
          const box = document.getElementById(boxId);
          if (box) {
            box.style.borderColor = "blue"; // Cambiar el color del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.borderWidth = "2px"; // Cambiar el grosor del borde aquÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â­
            box.style.backgroundColor = ''
          }
          // Remover todos los backdrops y mÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡scaras


          masks.forEach(mask => {
            mask.remove();
          });
        }





      } catch (error) {
        console.error("Error al obtener datos JSON:", error);
      }
    };
  };




  loadFillData(array) {
    const { isZoomed, mouseX, mouseY } = this.state;
    if (array.length > 0) {
      return array.map((data, index) => {
        const f = data.Source;
        const id = "f" + data.IDPhoto;
        const props = { width: 400, zoomWidth: 500, zoomPosition: 'original', img: f };
        var zoomedAreaStyle = {
          background: 'white',
          opacity: 0.4,
          position: 'absolute',
          width: 'auto',
          height: '400px',
          top: `${mouseY}px`,
          left: `${mouseX}px`,
          display: isZoomed ? 'block' : 'none',
        };

        var zoomedImageStyle = {
          backgroundImage: `url("${f}")`,
          backgroundRepeat: 'no-repeat',
          display: isZoomed ? 'block' : 'none',
          position: 'absolute',
          top: '0px',
          left: '0px',
          width: '100%',
          height: '100%',
          backgroundSize: '700px 800px',
          backgroundPosition: `${-1 * (mouseX - 50)}px ${-1 * (mouseY)}px`,
        };



        const cursorStyle = isZoomed ? { cursor: 'zoom-in' } : {};
        return (
          <div key={index} className="image-container" onMouseDown={this.handleMouseEnter}
            onMouseUp={this.handleMouseLeave} onMouseMove={this.handleMouseMove} style={cursorStyle}>
            <img

              id={data.IDPhoto}
              src={f}
              ref={this.imageRef}
              onLoad={() => this.handlePhotoLoad(index)}
              style={{ maxHeight: "400px", width: "auto" }}
            />
            <div className="js-image-zoom__zoomed-area" style={zoomedAreaStyle}></div>
            <div className="js-image-zoom__zoomed-image" style={zoomedImageStyle}></div>
          </div>
        )
      });
    } else {
      if (this.state.nfotos !== -1) {
        return (
          <div key={-1}>
            <div className="mh-empty-media">
              <i className="bx bx-image-alt" aria-hidden="true"></i>
              <h4>Sin fotos disponibles</h4>
              <p>Aun no hay evidencia multimedia asociada a este contrato.</p>
            </div>
          </div>
        )
      }
    }
  }


  /* Traer fotos  */
  async getFotos(contrato) {
    // console.log("# ENTRO A CONTRATO*************");
    try {
      this.setState({ nfotos: -1, currentIndex: 0, selectedItem: 0, loadingFotos: true });
      const infojson = this.getScopedElementById('infojson');
      const infoAddJson = this.getScopedElementById('infofoto2');
      if (infojson) infojson.innerHTML = "";
      if (infoAddJson) infoAddJson.innerHTML = "";
      let img = 'img'
      let data = { "contrato": contrato, "tipo": img } //Para video es vid;
      const json = JSON.stringify(data);
      if (contrato != -1) {
        // console.log("si hay contrato = " + contrato);
        const response = await axios.post(process.env.REACT_APP_SERVER + '/operaciones/getfotoscontrato', json, {
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
          withCredentials: true
        });
        if (response.data.success) {
          // console.log("si hay fotos", response.data.data);
          this.setState({ fotos: response.data.data });
          this.setState({ nfotos: 1 });
          if (response.data.data.length > 0) {
            this.mostrarInfo(response.data.data[0]);
          }

        } else {
          window.history.go(0);
        }
      } else {
        console.error("no hay contrato aun");
      }

    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loadingFotos: false });
    }
  }

  async trackingModal(e) {
    e.preventDefault();
    // console.log("entre a tracking");
    this.props.tracking();
  }

  async monitoreoModal(e) {
    e.preventDefault();
    // console.log("entre a monitoreo");
    this.props.monitoreo();
  }

  async consolidadoMonitoreo(e) {
    e.preventDefault();
    // console.log("entre a consolidado");
    this.props.consolidado();
  }


  /* Analizar fotos */
  async getFotosjSON(nombreimagen) {
    // console.log("***********" + nombreimagen);
    let token = localStorage.getItem('tkn');
    // console.log(token);
    try {
      var data = {
        "nombreimagen": nombreimagen
      };
      // console.log(data);
      const response = await axios.post(process.env.REACT_APP_SERVER + '/operaciones/getjsonvisuallogistic', JSON.stringify(data), {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        withCredentials: true
      });

      return response.data.info;
    } catch (error) {
      console.error(error);
    }
  }


  // FunciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n para renderizar la flecha previa del carrusel con un color personalizado
  renderCustomPrevArrow = (onClickHandler, hasPrev, label) =>
    hasPrev && (
      <button
        type="button"
        onClick={onClickHandler}
        title={label}
        style={{ backgroundColor: 'red', color: 'white' }} // Color personalizado para la flecha previa
      >
        Prev
      </button>
    );

  // FunciÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â³n para renderizar la flecha siguiente del carrusel con un color personalizado
  renderCustomNextArrow = (onClickHandler, hasNext, label) =>
    hasNext && (
      <button
        type="button"
        onClick={onClickHandler}
        title={label}
        style={{ backgroundColor: 'blue', color: 'white' }} // Color personalizado para la flecha siguiente
      >
        Next
      </button>
    );


  renderThumbsArrows = ({ direction, onClick }) => (
    <button className={`thumbs-arrow thumbs-${direction}`} onClick={onClick} style={{ color: 'blue' }}>
      {direction === 'prev' ? '<' : '>'}
    </button>
  );

  render() {
    const selectedPhotoInfo = this.state.selectedPhotoInfo;
    const infoHeaderLines = selectedPhotoInfo
      ? [
          selectedPhotoInfo?.Evento || "",
          `${this.state.infoContainerNum || ""}${selectedPhotoInfo?.Descripcion ? ` - ${selectedPhotoInfo.Descripcion}` : ""}`,
          `${selectedPhotoInfo?.Latitud || ""}${selectedPhotoInfo?.Longitud ? ` , ${selectedPhotoInfo.Longitud}` : ""}`,
          selectedPhotoInfo?.Nombreempresa || "",
          selectedPhotoInfo?.Hora || "",
        ].filter((line) => String(line || "").trim() !== "")
      : [];

    return (
      <div ref={this.galleryRootRef}>
        {this.props.showQuickLinks !== false && (
          <MDBRow style={{ marginTop: '-15px', marginBottom: '10px' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <a href="#" onClick={(e) => { this.trackingModal(e) }}>Tracking</a>&nbsp;/&nbsp;<a href="#" onClick={(e) => { this.monitoreoModal(e) }}>Monitoreo</a>&nbsp;/&nbsp;<a href="#" onClick={(e) => { this.consolidadoMonitoreo(e) }}>Consolidado</a>
            </div>
          </MDBRow>
        )}
        <MDBRow>
          {this.state.loadingFotos && (
            <div className="mh-skeleton-wrap">
              <div className="mh-skeleton-media"></div>
              <div className="mh-skeleton-panel"></div>
            </div>
          )}
          {!this.state.loadingFotos && (
            <>
          <MDBCol md='6' style={{ margin: '0', padding: '0' }}>
            <div id="prueba">
              <Carousel selectedItem={this.state.selectedItem} showArrows={true} showThumbs={true} showStatus={true} showIndicators={false} renderThumbsArrows={this.renderThumbsArrows} className="custom-carousel" onChange={this.handleChange}

              >
                {this.loadFillData(this.state.fotos)}

              </Carousel>

            </div>
          </MDBCol>
          <MDBCol id="panelinfo" md='6' className="mh-panel-shell" style={{ margin: '0', padding: '0' }}>
            <div className="mh-panel-title">Informacion</div>
            <div id="infofoto" className="mh-info-card" style={{ padding: '5px', color: '#000', fontWeight: 700, textAlign: 'center' }}>
              {infoHeaderLines.map((line, index) => (
                <div key={`info-line-${index}`}>{line}</div>
              ))}
            </div>
            <div className="d-flex flex-column flex-md-row w-100 mh-analytics-shell">

              <MDBRow className="w-100 m-0">
                <MDBCol md="6" className="p-0">
                  <div className="mh-analytics-header mh-analytics-header-tools">
                    <span className="mh-analytics-title">Image Analytics</span>
                    <div className="mh-analytics-actions">
                      <button
                        type="button"
                        className="mh-analytics-action-btn"
                        title="Actualizar analitica"
                        onClick={this.handleClick}
                      >
                        <img
                          src="/images/reload.png"
                          alt="Actualizar analitica"
                          className="mh-analytics-icon"
                        />
                      </button>
                      <button
                        type="button"
                        className="mh-analytics-action-btn"
                        title="Quitar bounding boxes"
                        onClick={this.eliminar}
                      >
                        <i className='bx bxs-trash bx-sm bx-tada-hover mh-analytics-icon'></i>
                      </button>
                    </div>
                  </div>
                  <div
                    id="infojson"
                    className="mh-analytics-body mh-analytics-body-left"
                    style={{ padding: '5px', color: '#000', height: '300px', overflow: 'auto' }}
                  >
                    {/* Contenido JSON */}
                  </div>
                </MDBCol>

                <MDBCol md="6" className="p-0">
                  <div className="mh-analytics-header">
                    <span className="mh-analytics-title">In-depth Analysis</span>
                  </div>
                  <div
                    id="infofoto2"
                    className="mh-analytics-body mh-analytics-body-right"
                    style={{ padding: '5px', color: '#000', height: '300px', overflowY: 'scroll' }}
                  >
                    {/* AnÃƒÆ’Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÆ’Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÆ’Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¡lisis detallado */}
                  </div>
                </MDBCol>
              </MDBRow>


            </div>
            {this.state.containerOwner !== '' && this.state.containerCode !== '' ? (
              this.state.visibleContain ? (
                <div className="mh-status-banner is-success">El contenedor de la imagen coincide con el asignado</div>
              ) : (
                <div className="mh-status-banner is-danger">El contenedor de la imagen no coincide con el asignado</div>
              )
            ) : null}
          </MDBCol>
          </>
          )}

        </MDBRow >

      </div>

    );
  }
}



export default Gallery;









